import React, { useState } from "react";
import { Field } from "formik";
import { Button, Col, Input, Row } from "components/bootstrap";
import { ConfirmDialog } from "components/common";
import AppConfig from "util/AppConfig";
import useRepositories from "./repository-management/hooks/useRepositories";
import CreateRepositoryModal from "./repository-management/CreateRepositoryModal";
import RepositorySelect from "./repository-management/RepositorySelect";
const RepositoryManagement = ({ valuesPrefix = void 0, disabled = false }) => {
  const isCloud = AppConfig.isCloud();
  const [showCreationModal, setShowCreationModal] = useState(false);
  const [showConfirmDeleteDialog, setShowConfirmDeleteDialog] = useState(false);
  const [repoToDelete, setRepoToDelete] = useState(void 0);
  const { onDeleteRepository } = useRepositories();
  const handleDelete = (event, value) => {
    event.stopPropagation();
    setRepoToDelete(value);
    setShowConfirmDeleteDialog(true);
  };
  const handleCancelDelete = () => {
    setShowConfirmDeleteDialog(false);
    setRepoToDelete(void 0);
  };
  const onDelete = () => {
    onDeleteRepository(repoToDelete);
    setShowConfirmDeleteDialog(false);
    setRepoToDelete(void 0);
  };
  const fieldName = () => {
    if (valuesPrefix) {
      return `${valuesPrefix}.data_tiering.warm_tier_repository_name`;
    }
    return "data_tiering.warm_tier_repository_name";
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Field, { name: fieldName() }, ({ meta: { error } }) => /* @__PURE__ */ React.createElement(
    Input,
    {
      bsStyle: error ? "error" : void 0,
      help: "Which warm storage repository should this index set be stored in",
      error,
      id: "default-roles-select",
      label: "Repository"
    },
    /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 8 }, /* @__PURE__ */ React.createElement(RepositorySelect, { disabled, fieldName: fieldName(), handleDelete })), /* @__PURE__ */ React.createElement(Col, { md: 4, className: "text-right" }, !isCloud && /* @__PURE__ */ React.createElement(Button, { disabled, onClick: () => setShowCreationModal(true) }, "Create new warm storage repository")))
  )), /* @__PURE__ */ React.createElement(CreateRepositoryModal, { show: showCreationModal, hideModal: () => setShowCreationModal(false) }), showConfirmDeleteDialog && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show: showConfirmDeleteDialog,
      onConfirm: onDelete,
      onCancel: handleCancelDelete,
      title: "Delete warm storage repository"
    },
    /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, "You are about to delete the warm storage repository ", /* @__PURE__ */ React.createElement("strong", null, repoToDelete), ". This action cannot be undone."), /* @__PURE__ */ React.createElement("p", null, "Are you sure you want to continue?"))
  ));
};
export default RepositoryManagement;
